import {
  WorkspaceStreamEntity,
  WorkspaceStreamOutputView,
} from "@features/workspaces/types/workspace-stream";

export const workspaceStreamsTools = {
  convertToDomainEntity: (stream: WorkspaceStreamOutputView): WorkspaceStreamEntity => ({
    ...stream,
  }),
  sortByName: (a: WorkspaceStreamEntity, b: WorkspaceStreamEntity) =>
    (a.name ?? "").localeCompare(b.name ?? "", undefined, { sensitivity: "base" }),
};
